module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "clientList",
    class: {
      tableHeight: _vm.isExist, tabHeight: !_vm.isExist
    }
  }, [_c('el-table', {
    ref: "clientList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "row-class-name": _vm.setRowname,
      "border": "",
      "height": _vm.userTableHeight
    },
    on: {
      "expand-change": _vm.changeExpand
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.LOGIN) ? _c('client-list', {
          attrs: {
            "id": props.row.LOGIN,
            "pReportDate": _vm.pReportDate
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.tableHead), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": item.labelName,
        "prop": item.propName,
        "min-width": item.width,
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.propName == 'LOGIN') ? _c('span', [_c('span', {
            staticClass: "loginClass",
            on: {
              "click": function($event) {
                return _vm.getLoginInfo(scope.row.LOGIN)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.propName]))])]) : (item.propName == 'NAME') ? _c('span', [_c('span', {
            staticClass: "loginClass",
            on: {
              "click": function($event) {
                return _vm.getUserInfo(scope.row)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.propName]))])]) : _c('span', [_vm._v(_vm._s(scope.row[item.propName]))])]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "page-size": _vm.tablePageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "historyDialog",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "90%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.showtradeReport) ? _c('el-button', {
    class: {
      btnActive: _vm.isActive
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toPosition
    }
  }, [_vm._v(_vm._s(_vm.$t('button.positionReport')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: {
      btnActive: !_vm.isActive
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toHistory
    }
  }, [_vm._v(_vm._s(_vm.$t('button.tradingHistory')))]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": _vm.$t('button.to'),
      "start-placeholder": _vm.$t('button.startDate'),
      "end-placeholder": _vm.$t('button.endDate'),
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tradeLoading),
      expression: "tradeLoading"
    }],
    staticClass: "dialogContent"
  }, [_c('el-table', {
    ref: "clientTradeTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tradeTable,
      "stripe": "",
      "border": "",
      "height": "450"
    }
  }, _vm._l((_vm.tradeTableHead), function(item, index) {
    return (item.status) ? _c('el-table-column', {
      key: index,
      attrs: {
        "label": item.labelName,
        "prop": item.propName,
        "min-width": item.width
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tradeCurrentPage,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "page-size": _vm.tradePageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.tradeTotal
    },
    on: {
      "size-change": _vm.tradeSizeChange,
      "current-change": _vm.tradeCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "userDialog",
    attrs: {
      "title": _vm.$t('dialog.userInfo'),
      "visible": _vm.userVisible,
      "width": "50%",
      "before-close": _vm.closeUserinfo
    },
    on: {
      "update:visible": function($event) {
        _vm.userVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userInfoLoading),
      expression: "userInfoLoading"
    }]
  }, _vm._l((_vm.userInfoArr), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "userInfo"
    }, [_c('div', {
      staticClass: "userLabel"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "userValue"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e91e2b0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/clientList.vue
// module id = 1190
// module chunks = 1